import React from 'react';
import { SquareIconButton } from '../buttons/SquareIconButton';

export type InputStepperProps = {
	onChange: (value: number) => void;
	initialCount?: number;
	maxQuantity?: number;
};

export const InputStepper = ({ onChange, initialCount = 0, maxQuantity = Infinity }: InputStepperProps) => {
	return (
		<div className="grid grid-cols-3 w-[132px] h-11 text-white">
			<SquareIconButton
				variant='minus'
				onClick={() => {
					const newValue = initialCount - 1;
					onChange(newValue);
				}}
				disabled={initialCount === 0}
			/>
			<span className="flex justify-center items-center">{initialCount}</span>
			<SquareIconButton
				variant='add'
				onClick={() => {
					const newValue = initialCount + 1;
					if (newValue <= maxQuantity) {
						onChange(newValue);
					}
				}}
				disabled={initialCount >= maxQuantity}
			/>
		</div>
	);
};
